import PersonOffIcon from '@mui/icons-material/PersonOff'
import { Avatar, AvatarGroup, Tooltip, Typography } from '@mui/material'
import { GridRenderCellParams } from '@mui/x-data-grid-premium'
import { renderColorByString } from 'components/DataGrid/renderColorByString'
import { EntityAvatar } from 'theme/components/Avatar'
import { DensityStyleTypes, User } from 'types'

export const renderTextOnly = (params: GridRenderCellParams, queue: User, densityStyles: DensityStyleTypes) => {
  return (
    <>
      {queue ? (
        <Typography
          key={queue?.user_uuid}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            padding: densityStyles.padding,
            fontSize: densityStyles.fontSize,
            color: renderColorByString(queue?.role),
            textAlign: 'left',
          }}
        >
          {queue?.name || 'Unknown'}
        </Typography>
      ) : (
        <Typography
          key={`no-queue-${params?.row?.SK}`}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            padding: densityStyles.padding,
            fontSize: densityStyles.fontSize,
            color: 'text.disabled',
            textAlign: 'left',
          }}
        >
          None Assigned
        </Typography>
      )}
    </>
  )
}

export const userAvatar = (queue: User, densityStyles: DensityStyleTypes) => {
  if (queue) {
    return (
      <AvatarGroup
        key={queue?.user_uuid}
        max={densityStyles.avatarMax}
        spacing={densityStyles.avatarSpacing}
        slotProps={{
          additionalAvatar: {
            sx: { width: densityStyles.avatarSize, height: densityStyles.avatarSize },
          },
        }}
      >
        {/* <FlexRow> */}
        <EntityAvatar
          name={queue?.name}
          userId={queue?.user_uuid}
          photoUrl={queue?.image_512}
          size={densityStyles.size}
          showName={false}
          enableNav
          tooltip
        />
        {/* </FlexRow> */}
      </AvatarGroup>
    )
  }

  // 👇 Use children for icon
  return (
    <Avatar
      sx={{
        backgroundColor: 'background.defaultdim',
        height: densityStyles.avatarSize,
        width: densityStyles.avatarSize,
      }}
      alt="None Assigned"
    >
      <PersonOffIcon fontSize="small" color="disabled" />
    </Avatar>
  )
}
export const userAvatarGroup = (users: User[], densityStyles: DensityStyleTypes) => {
  if (users && users?.length > 0) {
    return (
      <AvatarGroup
        max={densityStyles.avatarMax}
        spacing={densityStyles.avatarSpacing}
        slotProps={{
          additionalAvatar: {
            sx: { width: densityStyles.avatarSize, height: densityStyles.avatarSize },
          },
        }}
      >
        {users?.map(u => {
          return (
            <Tooltip key={u?.user_uuid} title={u?.role || ''}>
              <Avatar
                src={u?.image_512}
                sx={{
                  border: `3px solid ${renderColorByString(u?.role)} !important`,
                  height: densityStyles.avatarSize,
                  width: densityStyles.avatarSize,
                }}
              />
            </Tooltip>
          )
        })}
      </AvatarGroup>
    )
  }

  // 👇 Use children for icon
  return (
    <Avatar
      sx={{
        backgroundColor: 'background.defaultdim',
        height: densityStyles.avatarSize,
        width: densityStyles.avatarSize,
      }}
      alt="None Assigned"
    >
      <PersonOffIcon fontSize="small" color="disabled" />
    </Avatar>
  )
}
